import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime-corejs2/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import Vue from 'vue';
import QBtn from "../btn/QBtn.js";
import DarkMixin from "../../mixins/dark.js";
import { PanelParentMixin } from "../../mixins/panel.js";
import FullscreenMixin from "../../mixins/fullscreen.js";
import { isNumber } from "../../utils/is.js";
import { mergeSlot } from "../../utils/slot.js";
import cache from "../../utils/cache.js";
export default Vue.extend({
  name: 'QCarousel',
  mixins: [DarkMixin, PanelParentMixin, FullscreenMixin],
  props: {
    height: String,
    padding: Boolean,
    controlType: {
      type: String,
      validator: function validator(v) {
        return ['regular', 'flat', 'outline', 'push', 'unelevated'].includes(v);
      },
      default: 'flat'
    },
    controlColor: String,
    controlTextColor: String,
    autoplay: [Number, Boolean],
    arrows: Boolean,
    prevIcon: String,
    nextIcon: String,
    navigation: Boolean,
    navigationPosition: {
      type: String,
      validator: function validator(v) {
        return ['top', 'right', 'bottom', 'left'].includes(v);
      }
    },
    navigationIcon: String,
    navigationActiveIcon: String,
    thumbnails: Boolean
  },
  computed: {
    style: function style() {
      if (this.inFullscreen !== true && this.height !== void 0) {
        return {
          height: this.height
        };
      }
    },
    direction: function direction() {
      return this.vertical === true ? 'vertical' : 'horizontal';
    },
    classes: function classes() {
      return "q-carousel q-panel-parent q-carousel--with".concat(this.padding === true ? '' : 'out', "-padding") + (this.inFullscreen === true ? ' fullscreen' : '') + (this.isDark === true ? ' q-carousel--dark q-dark' : '') + (this.arrows === true ? " q-carousel--arrows-".concat(this.direction) : '') + (this.navigation === true ? " q-carousel--navigation-".concat(this.navigationPositionComputed) : '');
    },
    arrowIcons: function arrowIcons() {
      var ico = [this.prevIcon || this.$q.iconSet.carousel[this.vertical === true ? 'up' : 'left'], this.nextIcon || this.$q.iconSet.carousel[this.vertical === true ? 'down' : 'right']];
      return this.vertical === false && this.$q.lang.rtl === true ? ico.reverse() : ico;
    },
    navIcon: function navIcon() {
      return this.navigationIcon || this.$q.iconSet.carousel.navigationIcon;
    },
    navActiveIcon: function navActiveIcon() {
      return this.navigationActiveIcon || this.navIcon;
    },
    navigationPositionComputed: function navigationPositionComputed() {
      return this.navigationPosition || (this.vertical === true ? 'right' : 'bottom');
    },
    controlProps: function controlProps() {
      var _ref;

      return _ref = {
        color: this.controlColor,
        textColor: this.controlTextColor,
        round: true
      }, _defineProperty(_ref, this.controlType, true), _defineProperty(_ref, "dense", true), _ref;
    },
    transitionPrevComputed: function transitionPrevComputed() {
      return this.transitionPrev || "fade";
    },
    transitionNextComputed: function transitionNextComputed() {
      return this.transitionNext || "fade";
    }
  },
  watch: {
    value: function value() {
      if (this.autoplay) {
        clearInterval(this.timer);

        this.__startTimer();
      }
    },
    autoplay: function autoplay(val) {
      if (val) {
        this.__startTimer();
      } else {
        clearInterval(this.timer);
      }
    }
  },
  methods: {
    __startTimer: function __startTimer() {
      this.timer = setTimeout(this.next, isNumber(this.autoplay) ? this.autoplay : 5000);
    },
    __getNavigationContainer: function __getNavigationContainer(h, type, mapping) {
      return h('div', {
        class: 'q-carousel__control q-carousel__navigation no-wrap absolute flex' + " q-carousel__navigation--".concat(type, " q-carousel__navigation--").concat(this.navigationPositionComputed) + (this.controlColor !== void 0 ? " text-".concat(this.controlColor) : '')
      }, [h('div', {
        staticClass: 'q-carousel__navigation-inner flex flex-center no-wrap'
      }, this.__getEnabledPanels().map(mapping))]);
    },
    __getContent: function __getContent(h) {
      var _this = this;

      var node = [];

      if (this.navigation === true) {
        var fn = this.$scopedSlots['navigation-icon'] !== void 0 ? this.$scopedSlots['navigation-icon'] : function (opts) {
          return h(QBtn, {
            key: 'nav' + opts.name,
            class: "q-carousel__navigation-icon q-carousel__navigation-icon--".concat(opts.active === true ? '' : 'in', "active"),
            props: opts.btnProps,
            on: cache(_this, 'nav#' + opts.name, {
              click: opts.onClick
            })
          });
        };
        var maxIndex = this.panels.length - 1;
        node.push(this.__getNavigationContainer(h, 'buttons', function (panel, index) {
          var name = panel.componentOptions.propsData.name;
          var active = _this.panelIndex === index;
          return fn({
            index: index,
            maxIndex: maxIndex,
            name: name,
            active: active,
            btnProps: _objectSpread({
              icon: active === true ? _this.navActiveIcon : _this.navIcon,
              size: 'sm'
            }, _this.controlProps),
            onClick: function onClick() {
              _this.goTo(name);
            }
          });
        }));
      } else if (this.thumbnails === true) {
        var color = this.controlColor !== void 0 ? " text-".concat(this.controlColor) : '';
        node.push(this.__getNavigationContainer(h, 'thumbnails', function (panel) {
          var slide = panel.componentOptions.propsData;
          return h('img', {
            class: "q-carousel__thumbnail q-carousel__thumbnail--".concat(slide.name === _this.value ? '' : 'in', "active") + color,
            attrs: {
              src: slide.imgSrc
            },
            key: 'tmb#' + slide.name,
            on: cache(_this, 'tmb#' + slide.name, {
              click: function click() {
                _this.goTo(slide.name);
              }
            })
          });
        }));
      }

      if (this.arrows === true && this.panelIndex >= 0) {
        if (this.infinite === true || this.panelIndex > 0) {
          node.push(h('div', {
            key: 'prev',
            staticClass: "q-carousel__control q-carousel__arrow q-carousel__prev-arrow q-carousel__prev-arrow--".concat(this.direction, " absolute flex flex-center")
          }, [h(QBtn, {
            props: _objectSpread({
              icon: this.arrowIcons[0]
            }, this.controlProps),
            on: cache(this, 'prev', {
              click: this.previous
            })
          })]));
        }

        if (this.infinite === true || this.panelIndex < this.panels.length - 1) {
          node.push(h('div', {
            key: 'next',
            staticClass: "q-carousel__control q-carousel__arrow q-carousel__next-arrow q-carousel__next-arrow--".concat(this.direction, " absolute flex flex-center")
          }, [h(QBtn, {
            props: _objectSpread({
              icon: this.arrowIcons[1]
            }, this.controlProps),
            on: cache(this, 'next', {
              click: this.next
            })
          })]));
        }
      }

      return mergeSlot(node, this, 'control');
    },
    __renderPanels: function __renderPanels(h) {
      return h('div', {
        style: this.style,
        class: this.classes,
        on: _objectSpread({}, this.qListeners)
      }, [h('div', {
        staticClass: 'q-carousel__slides-container',
        directives: this.panelDirectives
      }, this.__getPanelContent(h))].concat(this.__getContent(h)));
    }
  },
  mounted: function mounted() {
    this.autoplay && this.__startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
});